import React from 'react';
import styled from 'styled-components';
import { cells, span, grid } from '../../styling/utils/grid';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { text } from '../../styling/mixins/typography';
import { getColor } from '../../styling/mixins/colors';

const StyledResultLinkWrapper = styled.div`
  ${grid}
  margin-bottom: 1.6rem;
  ${breakpoint('small')} {
    ${cells(1)}
  }
  ${breakpoint('medium')} {
    ${cells(4)}
  }
  .link-item {
    ${text('medium')}
    ${span(1)}
    text-decoration: none;
    cursor: pointer;
    color: ${getColor('grey', 900)};
  }
`;

const SearchResultLinkTab = ({ items }) => {
  return (
    <StyledResultLinkWrapper>
      {items.value.map((item) => {
        return (
          <a className="link-item" key={item.id} href={item.url}>
            {item.name}
          </a>
        );
      })}
    </StyledResultLinkWrapper>
  );
};
export default SearchResultLinkTab;
